// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ToggleEl} from 'common/components/toggle';
import {ToggleTheme} from 'common/components/toggle/types';
import {FormattedProperty} from 'common/util/format-property';
import {
  FormattedPropertyLayout,
  FormattedPropertyMixin,
} from 'common/widgets/profile-activity/formatted-property/template';

import {EventPropertyToggleChoices} from './types';
import type {ProfileActivityProperties} from './index';

export function template(this: ProfileActivityProperties) {
  const {selectedToggle} = this.state;
  const {allProperties, userDefinedProperties, mixpanelProperties} = this.helpers.splitPropertiesForEvent();

  const ShowProperties = ({properties}: {properties: FormattedProperty[]}) => (
    <div sel='.event-properties'>
      {properties.map((property) => (
        <div sel='.property-row'>
          <FormattedPropertyMixin property={property} layout={FormattedPropertyLayout.Horizontal} />
        </div>
      ))}
    </div>
  );

  return (
    <div sel='.single-event-properties'>
      <div sel='.event-properties-wrapper'>
        <div sel='.properties-title'>
          <ToggleEl
            attrs={{
              theme: ToggleTheme.SegmentedController,
              selected: selectedToggle,
              options: this.helpers.propertiesToggleOptions({
                allPropertiesLength: allProperties.length,
                userDefinedPropertiesLength: userDefinedProperties.length,
                mixpanelLength: mixpanelProperties.length,
              }),
            }}
            on={{
              select: this.helpers.onToggleChange,
            }}
          />
        </div>
        <ShowProperties
          properties={
            selectedToggle === EventPropertyToggleChoices.ALL_EVENT_PROPERTIES
              ? allProperties
              : selectedToggle === EventPropertyToggleChoices.USER_DEFINED_EVENT_PROPERTIES
                ? userDefinedProperties
                : mixpanelProperties
          }
        />
      </div>
    </div>
  );
}
